import { image } from './branchetv4'
import { parse, format } from 'libphonenumber-js'
import moment from 'moment'
moment.locale('fr')

export default function newBranchet (pdf, titulaire, remplacant, contrat) {
  pdf.image(image(), 0, 0, { scale: 0.35 })
  //
  pdf.text(titulaire.fullName.toUpperCase(), 70, 160)
  pdf.text(' ' + remplacant.nom.toUpperCase(), 200, 215)
  pdf.text(remplacant.prenom.toUpperCase(), 200, 235)
  pdf.text(remplacant.adresse, 200, 255)
  if (remplacant.dateNaiss) {
    pdf.text(moment(remplacant.dateNaiss).format('DD/MM/YYYY') + '', 200, 295)
  }
  pdf.text(' ' + remplacant.lieuNaiss + '', 200, 315)
  pdf.text(' Française ', 200, 335)
  var tel = parse(remplacant.telephone, 'FR')
  pdf.text('  ' + format(tel, 'National') + '', 200, 375)
  pdf.text(' ' + remplacant.email + '', 200, 392)
  pdf.text('ANESTHESISTE REANIMATEUR', 200, 415)
  pdf.text(moment(contrat.date1).format('DD/MM/YYYY'), 80, 488)
  pdf.text('Le ---', 25, 486)
  pdf.text('Le ---', 25, 506)
  pdf.text('Le ---', 25, 526)
  pdf.text('Le ---', 290, 486)
  pdf.text('Le ---', 290, 506)
  pdf.text('Le ---', 290, 526)
  if (contrat.date2) {
    pdf.text(moment(contrat.date2).format('DD/MM/YYYY'), 80, 508)
  }
  if (contrat.date3) {
    pdf.text(moment(contrat.date3).format('DD/MM/YYYY'), 80, 528)
  }
  if (contrat.date4) {
    pdf.text(moment(contrat.date4).format('DD/MM/YYYY'), 350, 488)
  }
  if (contrat.date5) {
    pdf.text(moment(contrat.date5).format('DD/MM/YYYY'), 350, 508)
  }
  if (contrat.date6) {
    pdf.text(moment(contrat.date6).format('DD/MM/YYYY'), 350, 228)
  }
  if (remplacant.autreAssurance) {
    pdf.lineWidth(2)
    pdf.rect(155, 575, 40, 30).stroke()
    pdf.text('voir document joint ', 200, 600)
  } else {
    pdf.lineWidth(2)
    pdf.rect(55, 575, 40, 30).stroke()
  }
  pdf.text(moment(contrat.createdAt).format('DD/MM/YYYY'), 200, 670)
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/branchetFn.js